import { translate } from '../../../Services/translation';
import { LoginModes } from '../../../constants';

export const getTitle = (state) => {
  switch (state) {
    case LoginModes.ChangePassword:
      return translate('login.title.change-password');
    case LoginModes.ForgotPassword:
      return translate('login.title.forgot-password');
    case LoginModes.SelectOrganization:
      return translate('login.title.select-organization');
    default:
      return translate('login.title.login');
  }
};
